import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import styled from 'styled-components';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { INLINES } from '@contentful/rich-text-types';
import { useSelector } from 'react-redux';
import { RootState } from '@/store/store';
import { CollectionPageContent } from '@/types/collections';

interface ICollectionFooter {
  bottomDescriptionRich: CollectionPageContent['bottomDescriptionRich'];
  locale: string;
}

const FooterCollection = styled.div`
  text-align: center;
  width: 75%;
  margin: 0 auto;
  margin-bottom: 48px;
`;

const StyledAnchor = styled.a`
  color: ${props => props.theme.paletteDefault.primary.main};
  cursor: pointer;
  text-decoration: underline;
`;

const CollectionFooter: React.FC<ICollectionFooter> = ({
  bottomDescriptionRich,
  locale,
}) => {
  const storeCollectionInfo = useSelector(
    (state: RootState) => state.collectionInfoReducer.collectionInfo
  );

  const [footerDesc, setFooterDesc] = useState({
    bottomDescriptionRich: bottomDescriptionRich,
  });

  useEffect(() => {
    if (storeCollectionInfo && Object.keys(storeCollectionInfo).length > 0) {
      setFooterDesc({
        bottomDescriptionRich: storeCollectionInfo.bottomDescriptionRich,
      });
    }
  }, [storeCollectionInfo]);

  let options;
  if (footerDesc?.bottomDescriptionRich) {
    options = {
      renderNode: {
        [INLINES.HYPERLINK]: (node: any) => {
          if (node.content && node.content.length > 0) {
            return (
              <Link href={node.data.uri} locale={locale} passHref>
                <StyledAnchor>{node.content[0].value}</StyledAnchor>
              </Link>
            );
          } else {
            return null;
          }
        },
      },
    };
  }

  return (
    <>
      {footerDesc?.bottomDescriptionRich && (
        <FooterCollection>
          {documentToReactComponents(footerDesc.bottomDescriptionRich, options)}
        </FooterCollection>
      )}
    </>
  );
};

export default CollectionFooter;
